import styled, { css } from 'styled-components'
import { ReactComponent as ClockwiseArrowCircle } from '@sketch/icons/arrow-clockwise-17'
import { Button } from '@sketch/components'

export const StyledClockwiseArrowCircle = styled(ClockwiseArrowCircle)`
  width: 17px;
  height: 17px;
`

export const StyledConsolidateButton = styled(Button)(
  ({ loading }) => css`
    padding: ${loading ? '6px 16px' : '6px 8px'};
  `
)
